
$(document).ready(function(){
  /*
  $('.btn.btn--callout span').each(function(){
    $(this).append('<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0679 8.10945C18.4585 7.71893 18.4585 7.08576 18.0679 6.69524L11.704 0.331276C11.3135 -0.0592484 10.6803 -0.0592484 10.2898 0.331276C9.89925 0.7218 9.89925 1.35497 10.2898 1.74549L15.9466 7.40234L10.2898 13.0592C9.89925 13.4497 9.89925 14.0829 10.2898 14.4734C10.6803 14.8639 11.3135 14.8639 11.704 14.4734L18.0679 8.10945ZM0.293945 8.40234H17.3608V6.40234H0.293945V8.40234Z" fill="#263056"/></svg>')
    
  });
  $('.meganav .btn.btn--overlay span').each(function(){
    $(this).append('<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0679 8.10945C18.4585 7.71893 18.4585 7.08576 18.0679 6.69524L11.704 0.331276C11.3135 -0.0592484 10.6803 -0.0592484 10.2898 0.331276C9.89925 0.7218 9.89925 1.35497 10.2898 1.74549L15.9466 7.40234L10.2898 13.0592C9.89925 13.4497 9.89925 14.0829 10.2898 14.4734C10.6803 14.8639 11.3135 14.8639 11.704 14.4734L18.0679 8.10945ZM0.293945 8.40234H17.3608V6.40234H0.293945V8.40234Z" fill="#263056"/></svg>') 
  });
  
  $('.meganav__primary ul li a').each(function(){
    $(this).append('<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0679 8.10945C18.4585 7.71893 18.4585 7.08576 18.0679 6.69524L11.704 0.331276C11.3135 -0.0592484 10.6803 -0.0592484 10.2898 0.331276C9.89925 0.7218 9.89925 1.35497 10.2898 1.74549L15.9466 7.40234L10.2898 13.0592C9.89925 13.4497 9.89925 14.0829 10.2898 14.4734C10.6803 14.8639 11.3135 14.8639 11.704 14.4734L18.0679 8.10945ZM0.293945 8.40234H17.3608V6.40234H0.293945V8.40234Z" fill="#263056"/></svg>') 
  }); 
  
  $('.popup .btn span').each(function(){
    $(this).append('<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0679 8.10945C18.4585 7.71893 18.4585 7.08576 18.0679 6.69524L11.704 0.331276C11.3135 -0.0592484 10.6803 -0.0592484 10.2898 0.331276C9.89925 0.7218 9.89925 1.35497 10.2898 1.74549L15.9466 7.40234L10.2898 13.0592C9.89925 13.4497 9.89925 14.0829 10.2898 14.4734C10.6803 14.8639 11.3135 14.8639 11.704 14.4734L18.0679 8.10945ZM0.293945 8.40234H17.3608V6.40234H0.293945V8.40234Z" fill="#263056"/></svg>')
    
  });
  $('button#Subscribe-footer').each(function(){
    $(this).html("Submit");
    $(this).append('<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0679 8.10945C18.4585 7.71893 18.4585 7.08576 18.0679 6.69524L11.704 0.331276C11.3135 -0.0592484 10.6803 -0.0592484 10.2898 0.331276C9.89925 0.7218 9.89925 1.35497 10.2898 1.74549L15.9466 7.40234L10.2898 13.0592C9.89925 13.4497 9.89925 14.0829 10.2898 14.4734C10.6803 14.8639 11.3135 14.8639 11.704 14.4734L18.0679 8.10945ZM0.293945 8.40234H17.3608V6.40234H0.293945V8.40234Z" fill="#263056"/></svg>')

  });
   $('.product__media-show-more .btn').each(function(){
    $(this).append('<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0679 8.10945C18.4585 7.71893 18.4585 7.08576 18.0679 6.69524L11.704 0.331276C11.3135 -0.0592484 10.6803 -0.0592484 10.2898 0.331276C9.89925 0.7218 9.89925 1.35497 10.2898 1.74549L15.9466 7.40234L10.2898 13.0592C9.89925 13.4497 9.89925 14.0829 10.2898 14.4734C10.6803 14.8639 11.3135 14.8639 11.704 14.4734L18.0679 8.10945ZM0.293945 8.40234H17.3608V6.40234H0.293945V8.40234Z" fill="#263056"/></svg>')

  }); 
  */
   
  $('.image.footer__image img').wrap("<a href='/'></a>"); 

  /* change button scroll to swatch king */  
  $('.swatch-king-trigger').on('click', function(e) {
    e.preventDefault();
    let target = $('.swatches-type-products');
    if (target.length) {
      let offset = target.offset().top - 120;
      $('html, body').animate({
        scrollTop: offset
      }, 1000); 
    }
  });

  /*open external links in new window*/
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
    
  /*tips popup*/
    $("#tips-modal-page-overlay").click(function(e){
      $('#tips-modal-popup').removeClass('show-modal')
      $('body').removeClass('overflow-hidden')
    }) 
    $("#close-tips-popup").click(function(e){
      $('#tips-modal-popup').removeClass('show-modal')
      $('body').removeClass('overflow-hidden')
    })  
    $("[id*='multi_column_YYBkcK'] a.multi-column__grid-item-image-wrapper").click(function(event) {
      event.preventDefault(); // Prevents the default link behavior
      var url = $(this).attr('href');
      console.log(url); // Outputs the href value to the console
      $('#tips-iframe').attr('src', url);
      $('#tips-modal-popup').addClass('show-modal')
      $('body').addClass('overflow-hidden')
    });
  /*size popup on faqs*/
    $("[id*='collapsible_row_list_ye7HMh'] #content-1 a").click(function(event) {
      event.preventDefault(); // Prevents the default link behavior
      var url = $(this).attr('href');
      $('#tips-iframe').attr('src', url);
      $('#tips-modal-popup').addClass('show-modal')
      $('body').addClass('overflow-hidden')
    });

  /*wrap quote in link*/
  $("[id*='quote_iDpzRY'] .quote__item").each(function(){
    var newslink = $(this).find('.quote__item-author span a').attr('href');
    //console.log(newslink); 
    $(this).find('h4 span p').wrapInner($('<a>', { "href": newslink, target: '_blank' }));
  });
  $("[id*='quote_bht7gV'] .quote__item").each(function(){
    var newslink = $(this).find('.quote__item-author span a').attr('href');
    //console.log(newslink); 
    $(this).find('h4 span p').wrapInner($('<a>', { "href": newslink, target: '_blank' }));
  });
  /*hide universal email popup on signup page*/
  if (window.location.href.includes("sign-up")) {
    $("#shopify-section-sections--23937321435441__popup").hide();
  }

  /* Sibling swatch click-to-swap on collection product cards */
  $(document).on('click', '.product-swatches-options__item--swatch-button', function (e) {
    e.preventDefault();

    var $button = $(this);
    var $li = $button.closest('[data-sibling-product-id]');
    var $item = $button.closest('.product-item');
    var swapId = $li.data('sibling-product-id');

    if (!swapId || !$item.length) return;
    if (String(swapId) === String($item.attr('data-current-product-id'))) return;

    var template = $item.find('template[data-sibling-swap-product-id="' + swapId + '"]')[0];
    if (!template) return;

    var clone = document.importNode(template.content, true);
    var replaceTargets = ['image-link', 'badges', 'title', 'price'];
    var quickShopTargets = ['quick-shop-hover', 'quick-shop-hoverless', 'quick-shop-beneath'];

    replaceTargets.forEach(function (target) {
      var live = $item.find('[data-swap-target="' + target + '"]')[0];
      var next = clone.querySelector('[data-swap-target="' + target + '"]');
      if (live && next) {
        live.replaceWith(next);
      }
    });

    // Quick-add/quick-view buttons already have their click behavior bound by theme.js to the
    // specific DOM node. Replacing that node (like the targets above) would silently drop the
    // listener, so update the existing button's attributes/content in place instead.
    quickShopTargets.forEach(function (target) {
      var liveWrap = $item.find('[data-swap-target="' + target + '"]')[0];
      var nextWrap = clone.querySelector('[data-swap-target="' + target + '"]');
      if (!liveWrap || !nextWrap) return;

      var liveButton = liveWrap.querySelector('[data-quick-shop-trigger]');
      var nextButton = nextWrap.querySelector('[data-quick-shop-trigger]');

      if (liveButton && nextButton) {
        ['data-quick-shop-trigger', 'data-product-id', 'data-product-url', 'title'].forEach(function (attr) {
          if (nextButton.hasAttribute(attr)) {
            liveButton.setAttribute(attr, nextButton.getAttribute(attr));
          } else {
            liveButton.removeAttribute(attr);
          }
        });
        liveButton.innerHTML = nextButton.innerHTML;
      } else if (liveButton && !nextButton) {
        liveWrap.innerHTML = '';
      } else if (!liveButton && nextButton) {
        liveWrap.replaceWith(nextWrap);
      }
    });

    $item.attr('data-current-product-id', swapId);
    $item.find('[data-sibling-product-id]').each(function () {
      var $siblingLi = $(this);
      var isSelected = String($siblingLi.data('sibling-product-id')) === String(swapId);
      $siblingLi.toggleClass('selected', isSelected);
      $siblingLi.find('.product-swatches-options__item--swatch-button').attr('aria-pressed', String(isSelected));
    });
  });

});

